<template>
    <section class="content">
        <div class="container-fluid">
            <div class="block-header">
                <h2>Log</h2>
            </div>
            <div class="row clearfix">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div class="card">
                        <div class="header">
                            <h2>
                                List Log
                            </h2>
                        </div>
                        <div class="body">
                                <div id="DataTables_Table_0_wrapper" class="dataTables_wrapper form-inline dt-bootstrap">
                                    <div class="row"><div class="col-sm-6"><div class="dataTables_length" id="DataTables_Table_0_length"><label>Show <select name="DataTables_Table_0_length" v-model="perPage" aria-controls="DataTables_Table_0" class="form-control input-sm"><option value="10">10</option><option value="25">25</option><option value="50">50</option><option value="100">100</option></select> entries</label></div></div><div class="col-sm-6"><div id="DataTables_Table_0_filter" class="dataTables_filter"><label>Search:<input v-model="search" type="search" class="form-control input-sm" placeholder="" aria-controls="DataTables_Table_0"></label></div></div></div>
                                    <table class="table table-bordered table-striped table-hover js-basic-example dataTable">
                                        <thead>
                                        <tr>
                                            <th>No.</th>
                                            <th>Nama</th>
                                            <th>Email</th>
                                            <th>Log</th>
                                            <th>IP</th>
                                            <th>Tanggal</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-if="isLoading">
                                                <td colspan="5" class="text-center"><i class="fa fa-spin fa-spinner"></i> Loading data...</td>
                                            </tr>
                                            <tr v-if="list == ''">
                                                <td colspan="5" class="text-center">Data tidak ditemukan</td>
                                            </tr>
                                            <tr v-if="!isLoading" v-for="(item, index) in list">
                                                <td>{{ ++index + ((currentPage-1)*perPage) }}</td>
                                                <td>{{ item.admin.namaLengkap }}</td>
                                                <td>{{ item.admin.email }}</td>
                                                <td>{{ item.log }}</td>
                                                <td>{{ item.ip }}</td>
                                                <td>{{ $moment(item.createdAt).format("Do MMMM YYYY HH:mm:ss") }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <pagination :total-rows="result.totalElements" :per-page="result.size" v-model="currentPage"></pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
  import api from '@/helper/api'
  import qs from 'qs'
  import FormLine from '@/components/FormLine.vue'

  export default {
    components: {FormLine},
    name: 'ListLog',
    data: function () {
      return {
        result: {},
        list: [],
        currentPage: 1,
        perPage: 10,
        search: '',
        modal: null,
        isLoading: true,
        link: '',
        tipe: '',
        nama: ''
      }
    },
    methods: {
      getData () {
        var params = []
        params.search = this.search
        params.page = this.currentPage - 1
        params.size = this.perPage

        this.isLoading = true

        api.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token')
        api.get('/log?' + qs.stringify(params)).then((result) => {
          this.result = result.data
          this.list = result.data.content
          this.isLoading = false
        }).catch((ex) => {
          this.isLoading = false
        })
      },
      delete (id) {
        api.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token')
        api.delete('/faq/' + id).then((result) => {
          if (result.data.code === 200) this.$toastr.s('Data berhasil dihapus.')
          else this.$toastr.e('Gagal menghapus data, terjadi kesalahan pada server.')
          this.$swal.close()
          this.getData()
        }).catch((e) => {
          this.$toastr.e('Gagal menghapus data, terjadi kesalahan pada server.')
          this.$swal.close()
        })
      }
    },
    mounted: function () {
      this.getData()
    },
    watch: {
      currentPage (e) {
        this.getData()
      },
      perPage (e) {
        this.getData()
      },
      search (e) {
        this.getData()
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/view/ListLog.vue?256fc163